/*
 * @Description:系统设置菜单配置
 * @Author: 琢磨先生
 * @Date: 2024-07-15 12:07:03
 * @LastEditors: 琢磨先生
 * @LastEditTime: 2024-08-18 17:33:00
 */
export default {
	path: '/',
	icon: '',
	component: '',
	meta: {
		title: '系统设置'
	},
	children: [
		{
			path: '/system/permission',
			name: 'permission',
			icon: 'ScaleToOriginal',
			component: () => import('@/views/system/permission'),
			power: 'admin/v1/todo',
			meta: {
				title: '权限策略'
			}
		},
		{
			path: '/system/function',
			name: 'SysFunctionIndex',
			icon: 'Paperclip',
			component: () => import('@/views/system/function'),
			power: 'admin/v1/todo',
			meta: {
				title: 'Api管理'
			}
		},
		// {
		// 	path: '/system/datafield',
		// 	icon: 'Coin',
		// 	component: () => import('@/views/system/datafield'),
		// 	power: 'admin/v1/todo',
		// 	meta: {
		// 		title: '权限字段'
		// 	}
		// },
		{
			path: '/system/tablefield',
			name: 'SysTableFieldIndex',
			icon: 'Coin',
			component: () => import('@/views/system/tablefield'),
			power: 'admin/v1/todo',
			meta: {
				title: '可选字段配置'
			}
		},
		{
			path: '/system/role',
			name: 'SysRoleIndex',
			icon: 'Pointer',
			component: () => import('@/views/system/role'),
			power: 'admin/v1/todo',
			meta: {
				title: '角色'
			}
		},
		// {
		// 	path: '/system/captcha',
		// 	icon: 'Promotion',
		// 	component: () => import('@/views/system/captcha'),
		// 	power: 'admin/v1/todo',
		// 	meta: {
		// 		title: '验证码'
		// 	}
		// },
		{
			path: '/system/setting',
			name: 'SysSettingIndex',
			icon: 'Tools',
			component: () => import('@/views/system/setting'),
			power: 'admin/v1/todo',
			meta: {
				title: '参数设置'
			}
		},

		{
			path: '/',
			icon: 'Memo',
			component: '',
			meta: {
				title: '日志管理'
			},
			children: [
				// {
				// 	path: '/system/log/error',
				// 	icon: '',
				// 	component: () => import('@/views/system/log/error'),
				// 	power: 'admin/v1/todo',
				// 	meta: {
				// 		title: '错误日志'
				// 	}
				// },
				{
					path: '/system/log/request',
					name: 'SysRequestIndex',
					icon: '',
					component: () => import('@/views/system/log/request'),
					power: 'admin/v1/todo',
					meta: {
						title: '请求日志'
					}
				}
			]
		},
		{
			path: '/',
			icon: '',
			component: '',
			meta: {
				title: '配置管理'
			},
			children: [
				// {
				// 	path: '/system/disposition/project',
				// 	icon: '',
				// 	component: () => import('@/views/system/disposition/project'),
				// 	power: 'admin/v1/todo',
				// 	meta: {
				// 		title: '项目负责人配置'
				// 	}
				// },
				{
					path: '/system/disposition/projects',
					name: 'SysProjectsIndex',
					icon: '',
					power: 'admin/v1/todo',
					component: () => import('@/views/system/projects'),
					meta: {
						title: '项目负责人配置'
					}
				},
				{
					path: '/system/disposition/ProjectBook',
					name: 'ProjectBookCenterIndex',
					icon: '',
					power: 'admin/v1/todo',
					component: () => import('@/views/system/ProjectBook'),
					meta: {
						title: '项目图书审核配置'
					}
				},
				{
					path: '/system/disposition/ClassScheduling',
					name: 'PaikeCenterIndex',
					icon: '',
					power: 'admin/v1/todo',
					component: () => import('@/views/system/Paike'),
					meta: {
						title: '排课审核配置'
					}
				},
				{
					path: '/system/disposition/ClassSchedulingCopy',
					name: 'ClassSchedulingCopy',
					icon: '',
					power: 'admin/v1/todo',
					component: () => import('@/views/system/paikeCopy'),
					meta: {
						title: '排课审核抄送配置'
					}
				},
				{
					path: '/system/disposition/customerServiceCenter',
					name: 'SysCustomerServiceCenterIndex',
					icon: '',
					power: 'admin/v1/todo',
					component: () => import('@/views/system/customerServiceCenter'),
					meta: {
						title: '客服中心配置'
					}
				},
				{
					path: '/system/disposition/educationalAdministration',
					name: 'SyseducationalAdministrationIndex',
					icon: '',
					power: 'admin/v1/todo',
					component: () => import('@/views/system/educationalAdministration'),
					meta: {
						title: '教务配置'
					}
				},
				{
					path: '/system/disposition/NationalProject',
					name: 'NationalProjectCenterIndex',
					icon: '',
					power: 'admin/v1/todo',
					component: () => import('@/views/system/NationalProject'),
					meta: {
						title: '全国项目'
					}
				},
				{
					path: '/system/disposition/publicoffice',
					name: 'SysPublicOfficeIndex',
					icon: '',
					power: 'admin/v1/todo',
					component: () => import('@/views/system/publicoffice'),
					meta: {
						title: '公职类型'
					}
				},
				{
					path: '/system/disposition/classSetting',
					name: 'classSetting',
					icon: '',
					power: 'admin/v1/todo',
					component: () => import('@/views/system/classSetting'),
					meta: {
						title: '省内外班次1-3天'
					}
				},
			
			]
		}
	]
}
